export default "__VITE_ASSET__DBKQ2MxF__"